import './semantic.min.css'
import './App.css'
import './ga'
import { Button, Container, Grid, Menu } from 'semantic-ui-react'
import React, { Component } from 'react'
import AboutMeSection from './sections/AboutMeSection'
import HelloSection from './sections/HelloSection'
import HowHelpSection from './sections/HowHelpSection'
import MediaQuery from 'react-responsive'
import PortfolioSection from './sections/PortfolioSection'
import Scroll from 'react-scroll'
import TechnologiesSection from './sections/TechnologiesSection'
import _ from 'lodash'

const Link = Scroll.Link
const Element = Scroll.Element
const Events = Scroll.Events
// const scroll = Scroll.animateScroll
const scrollSpy = Scroll.scrollSpy

class App extends Component {
	constructor(props) {
		super()

		this.state = {
			url: 'howIHelp'
		}

		this.changePageUrl = this.changePageUrl.bind(this)
		this.handleSetActive = this.handleSetActive.bind(this)
	}

	componentDidMount() {
		Events.scrollEvent.register('end', (to, element) => {
			this.setState({ url: to })
		})

		scrollSpy.update()
	}

	componentWillUnmount() {
		Events.scrollEvent.remove('begin')
		Events.scrollEvent.remove('end')
	}

	changePageUrl(url) {
		this.setState({ url })
	}

	handleSetActive(url) {
		this.setState({ url })
	}

	render() {
		const pages = [
			{
				url: 'howIHelp',
				title: 'How I help'
			},
			{
				url: 'portfolio',
				title: 'Portfolio'
			},
			{
				url: 'technologies',
				title: 'Technologies'
			},
			{
				url: 'summaries',
				title: 'About Me'
			},
			{
				url: 'contact',
				title: 'Contact me'
			}
		]
		const horizontalMenuWidth = 650
		return (
			<div className="App">
				<Container>
					<MediaQuery minWidth={horizontalMenuWidth}>
						<Menu size="large" fixed="top">
							{_.map(pages.slice(0, -1), page => (
								<Link
									activeClass="fake"
									key={page.url}
									className={this.state.url === page.url ? 'item active' : 'item'}
									to={page.url}
									spy={true}
									smooth={true}
									offset={-40}
									isDynamic={true}
									duration={500}
									onSetActive={this.handleSetActive}
								>
									{page.title}
								</Link>
							))}

							<Menu.Menu position="right">
								<Link
									activeClass="fake"
									className={'contact' === this.state.url ? 'item active' : 'item'}
									to="contact"
									spy={true}
									smooth={true}
									offset={-40}
									isDynamic={true}
									duration={500}
									onSetActive={this.handleSetActive}
								>
									<Button primary onClick={() => this.changePageUrl('contact')}>
										{_.last(pages).title}
									</Button>
								</Link>
							</Menu.Menu>
						</Menu>
					</MediaQuery>

					<HelloSection />
					<Element name="howIHelp" className="element">
						<HowHelpSection />
					</Element>

					<Element name="portfolio" className="element">
						<PortfolioSection />
					</Element>

					<Element name="technologies" className="element">
						<TechnologiesSection />
					</Element>

					<Element name="summaries" className="element">
						<AboutMeSection />
					</Element>

					<Element name="contact" className="element contact-section">
						<Grid columns="equal" stackable>
							<Grid.Column textAlign="center">
								<h2>Stalk</h2>
								<a
									href="https://github.com/AnthonyAstige"
									target="_blank"
									rel="noopener noreferrer"
								>
									<Button circular color="twitter" icon="github" />
								</a>
								<a
									href="https://www.linkedin.com/in/anthonyastige"
									target="_blank"
									rel="noopener noreferrer"
								>
									<Button circular color="linkedin" icon="linkedin" />
								</a>
							</Grid.Column>
							<Grid.Column textAlign="center">
								<h2>Contact</h2>
								<h4>
									<a href="AnthonyAstige@gmail.com">AnthonyAstige@gmail.com</a>
								</h4>
								<h4>(510) 982-6603</h4>
								{/*
								<h4>
									Skype: AnthonyAstige
								</h4>
								<p>
									I&#39;m generally online and happy to talk 10am-1pm M-F. This way I can
									focus on building things for you at other times.
								</p>
                                */}
							</Grid.Column>
						</Grid>
					</Element>
				</Container>
			</div>
		)
	}
}

export default App



// WEBPACK FOOTER //
// ./src/App.js